/*
 * @Author: Finget
 * @Date: 2020-04-24 17:23:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-22 15:49:31
 * @FilePath: /sdk/find_password/src/util/util.js
 */

export const appJS = function(fnName, params) {
  try {
    params = JSON.stringify(params);
    var u = navigator.userAgent,
      app = navigator.appVersion;
    console.log(app);
    var browser = {
      //IE内核
      trident: u.indexOf("Trident") > -1,
      //opera内核
      presto: u.indexOf("Presto") > -1,
      //苹果、谷歌内核
      webKit: u.indexOf("AppleWebKit") > -1,
      //火狐内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
      //是否为移动终端
      mobile: !!u.match(/AppleWebKit.*Mobile.*/),
      //ios终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      //android终端
      android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1,
      //是否为iPhone或者QQHD浏览器
      iPhone: u.indexOf("iPhone") > -1,
      //是否iPad
      iPad: u.indexOf("iPad") > -1,
      //是否web应该程序，没有头部与底部//是否web应该程序，没有头部与底部
      webApp: u.indexOf("Safari") == -1,
      //是否微信 （2015-01-22新增）
      weixin: u.indexOf("MicroMessenger") > -1,
      //是否QQ
      qq: u.match(/\sQQ/i) == " qq",
    };
    if (browser.ios) {
      execute("js-call-ios://" + fnName + "?params=" + params);
    } else if (browser.android) {
      // return
      var str = "window.local_obj." + fnName + "(params)";
      //字符串转function
      eval(str);
    }
  } catch (e) {
    console.error(e);
  }
};

function execute(url) {
  let iframe = document.createElement("IFRAME");
  iframe.setAttribute("src", url);
  document.documentElement.appendChild(iframe);
  iframe.parentNode.removeChild(iframe);
  iframe = null;
}

export const getUrlQuery = function(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
};

export const judgeDeviceType = function() {
  var ua = window.navigator.userAgent.toLocaleLowerCase();
  var isIOS = /iphone|ipad|ipod/.test(ua);
  var isAndroid = /android/.test(ua);
  var isMiuiBrowser = /miuibrowser/.test(ua);

  return {
    isIOS: isIOS,
    isAndroid: isAndroid,
    isMiuiBrowser: isMiuiBrowser,
  };
};

function activeElementScrollIntoView(activeElement, delay) {
  console.log(activeElement);
  var editable = activeElement.getAttribute("contenteditable");

  // 输入框、textarea或富文本获取焦点后没有将该元素滚动到可视区
  if (
    activeElement.tagName == "INPUT" ||
    activeElement.tagName == "TEXTAREA" ||
    editable === "" ||
    editable
  ) {
    setTimeout(function() {
      activeElement.scrollIntoView();
    }, delay);
  }
}

// 监听输入框的软键盘弹起和收起事件
export const listenKeybord = function($input, up, down) {
  // console.log('up', up);
  // console.log(judgeDeviceType());
  if (judgeDeviceType().isIOS) {
    // IOS 键盘弹起：IOS 和 Android 输入框获取焦点键盘弹起
    $input.addEventListener(
      "focus",
      function() {
        console.log("IOS 键盘弹起啦！");
        up && up();
        // IOS 键盘弹起后操作
      },
      false
    );

    // IOS 键盘收起：IOS 点击输入框以外区域或点击收起按钮，输入框都会失去焦点，键盘会收起，
    $input.addEventListener("blur", () => {
      console.log("IOS 键盘收起啦！");
      // IOS 键盘收起后操作
      down && down();
    });
  }

  // Andriod 键盘收起：Andriod 键盘弹起或收起页面高度会发生变化，以此为依据获知键盘收起
  if (judgeDeviceType().isAndroid || judgeDeviceType().isMiuiBrowser) {
    var originHeight =
      document.documentElement.clientHeight || document.body.clientHeight;

    window.addEventListener(
      "resize",
      function() {
        var resizeHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        if (originHeight < resizeHeight) {
          console.log("Android 键盘收起啦！");
          if (judgeDeviceType().isMiuiBrowser) {
            document.body.style.marginBottom = "0";
          }
          // Android 键盘收起后操作
          down && down();
        } else {
          up && up();
          if (judgeDeviceType().isMiuiBrowser) {
            document.body.style.marginBottom = "80px";
          }
          console.log("Android 键盘弹起啦！");
          activeElementScrollIntoView($input, 100);
          // Android 键盘弹起后操作
        }

        originHeight = resizeHeight;
      },
      false
    );
  }
};

//指定滚动到某处
/**
 *
 * @param $el 滚动的节点
 * @param value top, bottom, 100(px)
 */
export function goScrollView($el, value) {
  if ($el && $el.scrollHeight) {
    const scrollHeight = $el && $el.scrollHeight && $el.scrollHeight;
    console.log(scrollHeight);
    let num = 0;
    if (value === "top") {
      num = 0;
    }
    if (value === "bottom") {
      num = scrollHeight;
    } else if (num > 0) {
      num = value;
    }
    $el.scrollTo({
      left: 0,
      top: num,
      behavior: "smooth",
    });
  }
}

// 反转义html
export function escape2Html(str) {
  var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
    return arrEntities[t];
  });
}

export function dateFormat(timestamp) {
  if (String(timestamp).length === 10) {
    timestamp = timestamp * 1000;
  }
  const date = new Date(timestamp);
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  let time = date.getTime();
  month = month >= 10 ? month : "0" + month;
  day = day >= 10 ? day : "0" + day;
  hours = hours >= 10 ? hours : "0" + hours;
  minutes = minutes >= 10 ? minutes : "0" + minutes;
  seconds = seconds >= 10 ? seconds : "0" + seconds;
  time = time >= 10 ? time : "0" + time;
  return {
    year: year,
    month: month,
    day: day,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    time: time,
    ymd: year + "-" + month + "-" + day,
    ymdhm: year + "-" + month + "-" + day + " " + hours + ":" + minutes,
    ymdhms:
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds,
    mdhm: month + "-" + day + " " + hours + ":" + minutes,
    hms: hours + ":" + minutes + ":" + seconds,
    md: month + "-" + day,
    ms: minutes + ":" + seconds,
  };
}

export const createBase64Img = (file) => {
  if (!file) {
    return;
  }
  console.log(file);
  let oImg = document.createElement("img");
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function() {
    //alert('成功');
    oImg.src = this.result;
  };
  reader.onerror = function() {
    alert("读取失败了");
  };
  return oImg;
};

export function debounce(fn, delay = 500) {
  let timer = null;
  return function(...args) {
    let context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(context, args);
    }, delay);
  };
}

export const setDocumentTitle = function(title) {
  document.title = title;
  const ua = navigator.userAgent;
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/;
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement("iframe");
    i.src = "/favicon.ico";
    i.style.display = "none";
    i.onload = function() {
      setTimeout(function() {
        i.remove();
      }, 9);
    };
    document.body.appendChild(i);
  }
};

// 截取富文本内容
export function ellipsisHtml(html, size = 10) {
  let $div = document.createElement("div");
  html = escape2Html(html);
  $div.innerHTML = html;
  let $text = $div.innerText;
  let e = "";
  if ($text.length > size) {
    e = "...";
  }
  $text = $text.substr(0, size);
  $text += e;
  return $text;
}

// 复制文本
export function copyText(text) {
  return new Promise((resolve, reject) => {
    try {
      const input = document.createElement("textarea");
      document.body.appendChild(input);
      input.value = text;
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      resolve(text);
    } catch (error) {
      reject(error);
    }
  });
}

// 生成唯一key
export function createUniqueKey(length = 8) {
  return (
    Math.random()
      .toString()
      .substring(2)
      .substring(0, length) + Date.now().toString(36)
  );
}

// 获取url参数
export function getQuery(urlStr) {
  const url = decodeURIComponent(urlStr);
  let query = {};
  if (url.indexOf("?") != -1) {
    const str = url.split("?")[1] || "";
    const pairs = str.split("&");
    for (let i = 0; i < pairs.length; i += 1) {
      const pair = pairs[i].split("=");
      query[pair[0]] = pair[1];
    }
  }
  return query; // 返回对象
}
